module.exports = __webpack_public_path__ + "img/treppegelaender_tuer.fd5039ad.webp";